module.exports = __webpack_public_path__ + "static/media/PlanningBasics.bc25c7fb.png";